import { useEffect } from 'react';
import { CacheDataTypes } from '../types/cache';
import { Portals } from '../types/portal-switching';
import { extractEntityFromUrl, getContentCategory } from '../util/analytics-helpers';
import { trackEntityView } from '../util/google-analytics';

const ROUTE_ENTITY_TYPES = [
  ...Object.values(CacheDataTypes).filter((type) =>
    type === type.toLowerCase() && !type.startsWith('my-') &&
    !['account-request', 'account-templates', 'account-type', 'admin-user', 'brand', 'country',
      'device-type', 'feature', 'feature-type', 'feature-type-id-prefix', 'geofence-group',
      'lifecycle-template', 'model', 'my-accessible-account-type', 'oidc-group-mapping',
      'point-of-interest-set', 'self-claim', 'shared-thing', 'shared-thing-type',
      'user-group', 'variant'].includes(type),
  ),
  'poi',
  'alert',
] as const;

export const useTrackEntityView = (entityId?: string | null): void => {
  useEffect(() => {
    if (!entityId) return;

    const pathname = window.location.pathname;
    const hash = window.location.hash;
    const currentPath = pathname + hash;
    const portalPattern = new RegExp(`/(${Object.values(Portals).join('|')})(?:[/#]|$)`);
    const portalMatch = currentPath.match(portalPattern);
    const portal = portalMatch ? portalMatch[1] : null;

    if (!portal) return;

    const entityPattern = new RegExp(`/(${ROUTE_ENTITY_TYPES.join('|')})/`);
    const entityMatch = currentPath.match(entityPattern);

    if (!entityMatch) return;

    let entity = entityMatch[1];

    if (entity === 'poi') {
      entity = 'point-of-interest';
    }

    const contentCategory = getContentCategory(portal, entity);
    if (!contentCategory) return;

    const entityName = extractEntityFromUrl(`/api/v1/${entity}`);
    if (!entityName) return;

    trackEntityView(entityName, contentCategory);
  }, [entityId]);
};
